export default "__VITE_ASSET__xg6I1pbj__"